import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'powerLevel'
})
export class PowerLevelPipe implements PipeTransform {

    transform(power: any): number {
        try {
            return power.level;
        } catch (err) {
            return 0;
        }
    }

}
